import { render, staticRenderFns } from "./OrderPropertyListGroup.vue?vue&type=template&id=7ff791e6&"
import script from "./OrderPropertyListGroup.vue?vue&type=script&lang=js&"
export * from "./OrderPropertyListGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports